var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<span ng-if=\"form.$submitted && form.$error && nerrori\" ng-attr-title=\"{{(nerrori === '1' ? 'Sono presenti ' + nerrori + ' errori' : '&Eacute; presente un errore') +'. Correggi per procedere.'}}\">\n<i style=\"color: maroon\" class=\"fas fa-exclamation-triangle faa-shake animated\"></i>\n</span>\n";
var id1="formtabhaserror.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;